import { SurveyStatuses } from '../shared/survey-statuses';
import { ResultsStatuses } from '../results/results-statuses';

export interface SurveySummaryModel {
  id: string;
  moniker: string;
  participantName: string;
  name: string;
  organisationName: string;
  type: number;
  dateCreated: Date;
  dateOfClose: Date;
  dateOfReportRelease: Date;
  percentageComplete: number;
  isDeleted: boolean;
  hasReport: boolean;
  status: SurveyStatuses;
  isLocked: boolean;
  lockDate: Date;
  resultsStatus: ResultsStatuses;
  updated: Date;
  numberOfOthers: number;
  numberOfRespondents: number;
  campaignId: string;
}
